import React, { FC } from "react";
import { useSelector } from "react-redux";
import { ReduxState } from "~/types/redux";
import KioskCancelOrderStyled from "./KioskCancelOrderStyled";
import { useModal } from "~/hooks/useModal";
import Modal from "../Modal";
import { ModalKeys } from "~/constants/modal";
import CancelOrderModal from "../Modal/screens/KioskCancelOrderModal/CancelModal";

interface KioskCancelOrderProps {
  className?: string;
  display?: string;
}

const KioskCancelOrder: FC<KioskCancelOrderProps> = ({ className = "", display }) => {
  const { isVerizonKiosk } = useSelector((store: ReduxState) => store);
  const { openModal, activeModal } = useModal();

  if (!isVerizonKiosk) {
    return null;
  }

  const handleRedirect = () => {
    openModal(ModalKeys.KIOSK_CANCEL_ORDER);
  };

  return (
    <KioskCancelOrderStyled className={className} display={display}>
      Not ready to purchase?
      <span className="kiosk-cancel__link-wrapper">
        <button className="kiosk-cancel__link" onClick={handleRedirect}>
          Cancel order
        </button>
      </span>
      <Modal visible={activeModal === ModalKeys.KIOSK_CANCEL_ORDER} zIndex={9999}>
        <CancelOrderModal visible={activeModal === ModalKeys.KIOSK_CANCEL_ORDER} />
      </Modal>
    </KioskCancelOrderStyled>
  );
};

KioskCancelOrder.displayName = "KioskCancelOrder";

export default KioskCancelOrder;
